<div class="registerCard">
  <div class="card border-0">
    <div class="card-body">
      <div class="text-center">
        <img
          alt="Racebet365"
          src="assets/media/logos/racebet365.png"
          width="220"
          class="register-logo img-fluid"
        />
      </div>
      <h5 class="register-title">{{ "AUTH.REGISTER.TITLE" | translate }}</h5>
      <p class="register-desc">{{ "AUTH.REGISTER.DESC" | translate }}</p>

      <form [formGroup]="form" autocomplete="off" (ngSubmit)="submit()">
        <!-- Username -->
        <div class="form-group">
          <label for="reg-username">{{ "AUTH.INPUT.USERNAME" | translate }}</label>
          <input
            id="reg-username"
            class="borderInput p-inputtext-lg"
            type="text"
            formControlName="username"
            pInputText
            autocomplete="username"
            maxlength="32"
            (blur)="checkUsernameAvailability()"
            placeholder="{{ 'AUTH.INPUT.USERNAME' | translate }}"
          />
          <small *ngIf="checkingUsername" class="checking-hint">
            <i class="pi pi-spin pi-spinner"></i>
          </small>
          <small *ngIf="isControlHasError('username', 'required')" class="text-danger">
            {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small
          >
          <small *ngIf="isControlHasError('username', 'minlength')" class="text-danger">
            {{ "AUTH.VALIDATION.MIN_LENGTH_FIELD" | translate }} 3</small
          >
          <small *ngIf="isControlHasError('username', 'pattern')" class="text-danger">
            {{ "AUTH.REGISTER.USERNAME_PATTERN" | translate }}</small
          >
          <small *ngIf="isControlHasError('username', 'taken')" class="text-danger">
            {{ "AUTH.REGISTER.USERNAME_TAKEN" | translate }}</small
          >
        </div>

        <!-- Password -->
        <div class="form-group">
          <label for="reg-password">{{ "AUTH.INPUT.PASSWORD" | translate }}</label>
          <p-password
            inputId="reg-password"
            name="password"
            formControlName="password"
            [toggleMask]="true"
            [feedback]="false"
            class="p-inputtext-lg"
            placeholder="{{ 'AUTH.INPUT.PASSWORD' | translate }}"
          ></p-password>
          <small *ngIf="isControlHasError('password', 'required')" class="text-danger">
            {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small
          >
          <small *ngIf="isControlHasError('password', 'minlength')" class="text-danger">
            {{ "AUTH.REGISTER.PASSWORD_MIN" | translate }}</small
          >
          <small
            *ngIf="!isControlHasError('password', 'minlength') && isControlHasError('password', 'passwordPolicy')"
            class="text-danger"
          >
            {{ "AUTH.VALIDATION.PASSWORD_WEAK" | translate }}</small
          >
        </div>

        <!-- First + last name -->
        <div class="form-row-2col">
          <div class="form-group">
            <label for="reg-firstname">{{ "AUTH.REGISTER.FIRSTNAME" | translate }}</label>
            <input
              id="reg-firstname"
              class="borderInput p-inputtext-lg"
              type="text"
              formControlName="firstname"
              pInputText
              autocomplete="given-name"
              maxlength="100"
              placeholder="{{ 'AUTH.REGISTER.FIRSTNAME' | translate }}"
            />
            <small *ngIf="isControlHasError('firstname', 'required')" class="text-danger">
              {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small
            >
          </div>
          <div class="form-group">
            <label for="reg-lastname">{{ "AUTH.REGISTER.LASTNAME" | translate }}</label>
            <input
              id="reg-lastname"
              class="borderInput p-inputtext-lg"
              type="text"
              formControlName="lastname"
              pInputText
              autocomplete="family-name"
              maxlength="100"
              placeholder="{{ 'AUTH.REGISTER.LASTNAME' | translate }}"
            />
            <small *ngIf="isControlHasError('lastname', 'required')" class="text-danger">
              {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small
            >
          </div>
        </div>

        <!-- Email (optional) -->
        <div class="form-group">
          <label for="reg-email">{{ "AUTH.REGISTER.EMAIL_OPTIONAL" | translate }}</label>
          <input
            id="reg-email"
            class="borderInput p-inputtext-lg"
            type="email"
            formControlName="email"
            pInputText
            autocomplete="email"
            inputmode="email"
            maxlength="255"
            placeholder="{{ 'AUTH.INPUT.EMAIL' | translate }}"
          />
          <small *ngIf="isControlHasError('email', 'email')" class="text-danger">
            {{ "AUTH.REGISTER.EMAIL_INVALID" | translate }}</small
          >
          <small *ngIf="isControlHasError('email', 'taken')" class="text-danger">
            {{ "AUTH.REGISTER.EMAIL_TAKEN" | translate }}</small
          >
        </div>

        <!-- Mobile number -->
        <div class="form-group">
          <label for="reg-phone">{{ "AUTH.REGISTER.PHONE" | translate }}</label>
          <input
            id="reg-phone"
            class="borderInput p-inputtext-lg"
            type="tel"
            formControlName="phoneNumber"
            pInputText
            autocomplete="tel"
            inputmode="tel"
            maxlength="16"
            placeholder="{{ 'AUTH.REGISTER.PHONE_PLACEHOLDER' | translate }}"
          />
          <small *ngIf="isControlHasError('phoneNumber', 'required')" class="text-danger">
            {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small
          >
          <small *ngIf="isControlHasError('phoneNumber', 'pattern')" class="text-danger">
            {{ "AUTH.REGISTER.PHONE_INVALID" | translate }}</small
          >
        </div>

        <!-- Date of birth: day / month / year selects — no keyboard, no
             calendar-scrolling-through-decades, no date-format ambiguity -->
        <div class="form-group">
          <label>{{ "AUTH.REGISTER.DOB" | translate }}</label>
          <div class="dob-row">
            <p-dropdown
              [options]="dobDayOptions"
              formControlName="dobDay"
              optionLabel="label"
              optionValue="value"
              class="dob-select dob-select-day"
              placeholder="{{ 'AUTH.REGISTER.DAY' | translate }}"
              scrollHeight="220px"
              panelStyleClass="register-overlay-panel"
              appendTo="body"
              [baseZIndex]="overlayBaseZIndex"
              [style]="{ width: '100%' }"
            ></p-dropdown>
            <p-dropdown
              [options]="dobMonthOptions"
              formControlName="dobMonth"
              optionLabel="label"
              optionValue="value"
              class="dob-select dob-select-month"
              placeholder="{{ 'AUTH.REGISTER.MONTH' | translate }}"
              scrollHeight="220px"
              panelStyleClass="register-overlay-panel"
              appendTo="body"
              [baseZIndex]="overlayBaseZIndex"
              (onChange)="onDobSelectionChange()"
              [style]="{ width: '100%' }"
            ></p-dropdown>
            <p-dropdown
              [options]="dobYears"
              formControlName="dobYear"
              optionLabel="label"
              optionValue="value"
              class="dob-select dob-select-year"
              placeholder="{{ 'AUTH.REGISTER.YEAR' | translate }}"
              scrollHeight="220px"
              panelStyleClass="register-overlay-panel"
              appendTo="body"
              [baseZIndex]="overlayBaseZIndex"
              (onChange)="onDobSelectionChange()"
              [style]="{ width: '100%' }"
            ></p-dropdown>
          </div>
          <small *ngIf="dobTouched && dobMissing" class="text-danger">
            {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small
          >
          <small *ngIf="dobTouched && form.hasError('dobInvalid')" class="text-danger">
            {{ "AUTH.REGISTER.DOB_INVALID" | translate }}</small
          >
          <small *ngIf="dobTouched && form.hasError('dobUnderage')" class="text-danger">
            {{ "AUTH.REGISTER.UNDERAGE" | translate }}</small
          >
          <small class="field-hint">{{ "AUTH.REGISTER.DOB_HINT" | translate }}</small>
        </div>

        <!-- Country -->
        <div class="form-group">
          <label for="reg-country">{{ "CRYPTO.COUNTRY" | translate }}</label>
          <p-dropdown
            inputId="reg-country"
            [options]="countries"
            formControlName="countryId"
            optionLabel="name"
            optionValue="id"
            class="w-100"
            (onChange)="onCountryChange($event)"
            [style]="{ width: '100%' }"
            appendTo="body"
            [baseZIndex]="overlayBaseZIndex"
            panelStyleClass="register-overlay-panel"
          >
            <ng-template let-country pTemplate="item">
              <div class="d-flex align-items-center">
                <img
                  *ngIf="country.flag"
                  [src]="country.flag"
                  alt=""
                  style="width: 20px; height: 14px; margin-right: 8px"
                />
                <span>{{ country.name }}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="selectedItem">
              <div class="d-flex align-items-center" *ngIf="selectedCountry">
                <img
                  *ngIf="selectedCountry.flag"
                  [src]="selectedCountry.flag"
                  alt=""
                  style="width: 20px; height: 14px; margin-right: 8px"
                />
                <span>{{ selectedCountry.name }}</span>
              </div>
              <span *ngIf="!selectedCountry">{{ "SELECT_COUNTRY" | translate }}</span>
            </ng-template>
          </p-dropdown>
        </div>

        <!-- Currency: read-only, derived from the selected country (same
             disabled-dropdown pattern as the one-click flow) -->
        <div class="form-group">
          <label for="reg-currency">{{ "CRYPTO.CURRENCY" | translate }}</label>
          <p-dropdown
            inputId="reg-currency"
            [options]="countries"
            class="w-100"
            [disabled]="true"
            [style]="{ width: '100%' }"
          >
            <ng-template pTemplate="selectedItem">
              <div class="d-flex align-items-center" *ngIf="selectedCountry">
                <span>{{ selectedCountry.currency }}</span>
              </div>
              <span *ngIf="!selectedCountry">{{ "SELECT_CURRENCY" | translate }}</span>
            </ng-template>
          </p-dropdown>
        </div>

        <!-- Rate-limit lockout (shared with one-click) -->
        <div
          *ngIf="registrationLimited && registrationLimitMessage"
          class="registration-limit-notice mb-3"
        >
          <i class="pi pi-exclamation-triangle"></i>
          <div class="registration-limit-notice-text">
            <p class="mb-1">{{ registrationLimitMessage }}</p>
            <small *ngIf="registrationLimitHelper">{{ registrationLimitHelper }}</small>
          </div>
        </div>

        <!-- Generic submit error -->
        <div *ngIf="submitError" class="submit-error mb-3">
          <i class="pi pi-exclamation-triangle"></i>
          <span>{{ submitError }}</span>
        </div>

        <!-- reCAPTCHA -->
        <div class="recaptcha-container" *ngIf="!registrationLimited">
          <re-captcha
            #captchaRef
            (resolved)="onCaptchaResolved($event)"
            siteKey="{{ googleRecaptchaSiteKey }}"
          ></re-captcha>
        </div>

        <button
          type="submit"
          class="btn btn-warning btn-md font-lg btn-block d-flex align-items-center justify-content-center mb-2"
          [disabled]="submitDisabled"
        >
          <i
            *ngIf="submitting"
            class="pi pi-spin pi-spinner text-primary mr-2"
            style="font-size: 1.5rem"
          ></i>
          {{ "AUTH.REGISTER.CREATE_BUTTON" | translate }}
        </button>
      </form>
    </div>
  </div>
</div>
